// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"customsFee_flexContainer__18ACY","addInfoWrapper":"customsFee_addInfoWrapper__1vWQ3","horizontalLine":"customsFee_horizontalLine__1D7zU"};